<template>
  <div>
    <ScrollView
      class="DashScrollContainer"
      :refreshing="refreshing"
      @onRefresh="onRefresh"
      :empty="data.length === 0"
    >
      <div class="tree">
        <h3 class="textTotal">
          Total:{{ " " }}
          {{
            $formatter(
              topData.reduce((v, c) => v + c.getTotal(), 0),
              topData.every(e => e.moneda)
            )
          }}
        </h3>
        <TreeRow
          v-for="(item, index) of _data_"
          :key="`${item.ruta}_${index}`"
          :item="item"
          :collapses="collapses"
          :toggleCollapse="toggleCollapse"
          :zebra="!!(index % 2)"
          :separator="index>0"
        />
      </div>
      <template slot="Empty">
        <slot name="Empty" />
      </template>
    </ScrollView>
  </div>
</template>

<script>
//import moment from "moment";
import TreeRow from "./TreeRow.vue";
export default {
  name: "Tree",
  components: {
    TreeRow
  },
  props: {
    refreshing: {
      type: Boolean,
      default: false
    },
    onRefresh: {
      type: Function,
      default: () => {}
    },
    data: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    topData() {
      return this._data_.filter(ff => ff.ruta.split("/").length === 1);
    },
    _data_() {
      const reduceCollapses = (v, c) => {
        v.push(c);
        if (this.collapses.includes(c.ruta)) {
          v.push(...c.children.reduce(reduceCollapses, []));
        }
        return v;
      };
      const getTotal = function() {
        return this.children
          ? this.children.reduce((v, c) => {
              return v + c.getTotal();
            }, 0)
          : this.total || 0;
      };
      if (!this.data) {
        return [];
      }
      const data = this.data;

      return data
        .sort((a, b) =>
          a.concepto_ruta_nombre.localeCompare(b.concepto_ruta_nombre)
        )
        .reduce((v, c) => {
          const rutas = c.concepto_ruta_nombre.slice(1, -1).split("/");
          let pointer = v;
          let ruta_ = "";
          rutas.forEach(ruta => {
            ruta_ += `${ruta_ ? "/" : ""}${ruta}`;
            let found = pointer.find(f => f.concepto === ruta);
            if (!found) {
              let index = pointer.push({
                ruta: ruta_,
                concepto: ruta,
                getTotal,
                children: []
              });
              found = pointer[index - 1];
            }
            pointer = found.children;
          });
          pointer.push({ ...c, getTotal, ruta: `${ruta_}/${c.concepto}` });
          return v;
        }, [])
        .reduce(reduceCollapses, []);
    }
  },
  data() {
    return {
      collapses: []
    };
  },
  methods: {
    setCollapses(collapses) {
      this.collapses = collapses;
    },
    toggleCollapse(concepto) {
      if (this.collapses.includes(concepto)) {
        this.setCollapses(this.collapses.filter(ff => !ff.includes(concepto)));
      } else {
        this.setCollapses([...this.collapses, concepto]);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.tree {
  .textTotal {
    text-align: right;
    font-weight: bold;
    font-size: 25px;
    color: #000;
  }
}
</style>
